
  
  
  export const bitcoin = [
    { date: new Date(2015, 10, 15), price: 1 },
    { date: new Date(2015, 11, 17), price: 4 },
    { date: new Date(2016, 0, 16), price: 3 },
    { date: new Date(2016, 1, 21), price: 2 },
    { date: new Date(2016, 3, 25), price: 3 },
    { date: new Date(2016, 4, 29), price: 2 },
    { date: new Date(2016, 5, 20), price: 1.4 },
    { date: new Date(2016, 7, 5), price: 1.5 },
    { date: new Date(2016, 8, 14), price: 2.4 },
    { date: new Date(2016, 9, 30), price: 2.5 },
    { date: new Date(2016, 11, 21), price: 3 },
    { date: new Date(2017, 0, 8), price: 1 },
    { date: new Date(2017, 1, 9), price: 2 },
    { date: new Date(2017, 2, 9), price: 1.4 },
    { date: new Date(2017, 3, 6), price: 2.5 },
    { date: new Date(2017, 4, 4), price: 3 },
    { date: new Date(2017, 5, 11), price: 4 },
    { date: new Date(2017, 6, 19), price: 2 },
    { date: new Date(2017, 7, 18), price: 4 },
    { date: new Date(2017, 8, 19), price: 2 },
    { date: new Date(2017, 9, 19), price: 1 },
    { date: new Date(2017, 10, 14), price: 1.5 },
    { date: new Date(2017, 11, 22), price: 5 },
    { date: new Date(2018, 0, 23), price: 1 },
    { date: new Date(2018, 1, 10), price: 2 },
    { date: new Date(2018, 2, 6), price: 1.5 },
    { date: new Date(2018, 3, 7), price: 3 },
    { date: new Date(2018, 4, 9), price: 2 },
    { date: new Date(2018, 5, 6), price: 1 },
    { date: new Date(2018, 6, 18), price: 5 },
  ];

  

  export const confidence = [
    {
      date: 1, tvNews: 19, church: 29, military: 1,
    }, {
      date: 2, tvNews: 13, church: 32, military: 3,
    }, {
      date: 3, tvNews: 14, church: 35, military: 2.5,
    }, {
      date: 4, tvNews: 13, church: 32, military: 2,
    }, {
      date: 5, tvNews: 15, church: 28, military: 1,
    }, {
      date: 6, tvNews: 16, church: 27, military: 3,
    }, {
      date: 7, tvNews: 12, church: 28, military: 2.5,
    }, {
      date: 8, tvNews: 11, church: 26, military: 2,
    }, {
      date: 9, tvNews: 10, church: 25, military: 1.3,
    }, {
      date: 10, tvNews: 11, church: 25, military: 1,
    }, {
      date: 11, tvNews: 10, church: 25, military: 3,
    }, {
      date: 12, tvNews: 8, church: 20, military: 2,
    }, {
      date: 13, tvNews: 10, church: 20, military: 0.5,
    },
    {
      date: 14, tvNews: 19, church: 29, military: 1,
    }, {
      date: 15, tvNews: 13, church: 32, military: 4,
    }, {
      date: 16, tvNews: 14, church: 35, military: 2.5,
    }, {
      date: 17, tvNews: 13, church: 32, military: 2,
    }, {
      date: 18, tvNews: 15, church: 28, military: 1,
    }, {
      date: 19, tvNews: 16, church: 27, military: 3,
    }, {
      date: 20, tvNews: 12, church: 28, military: 2.5,
    }, {
      date: 21, tvNews: 11, church: 26, military: 4,
    }, {
      date: 22, tvNews: 10, church: 25, military: 1.3,
    }, {
      date: 23, tvNews: 11, church: 25, military: 1,
    }, {
      date: 24, tvNews: 10, church: 25, military: 3,
    }, {
      date: 25, tvNews: 8, church: 20, military: 2,
    }, {
      date: 26, tvNews: 10, church: 20, military: 0,
    },
    {
      date: 27, tvNews: 19, church: 29, military: 1,
    }, {
      date: 28, tvNews: 13, church: 32, military: 4,
    }, {
      date: 29, tvNews: 14, church: 35, military: 2.5,
    }, {
      date: 30, tvNews: 13, church: 32, military: 2,
    }
  ];
  

  
  export const booksSale = [{
    year: 1970, mysteries: 9, scienceFiction: 16, romance: 5, fantasy: 4, thrillers: 19,
  }, {
    year: 1971, mysteries: 15, scienceFiction: 18, romance: 2, fantasy: 4, thrillers: 14,
  }, {
    year: 1972, mysteries: 10, scienceFiction: 20, romance: 1, fantasy: 16, thrillers: 11,
  }, {
    year: 1973, mysteries: 12, scienceFiction: 17, romance: 15, fantasy: 5, thrillers: 14,
  }, {
    year: 1974, mysteries: 8, scienceFiction: 13, romance: 10, fantasy: 19, thrillers: 5,
  }, {
    year: 1975, mysteries: 7, scienceFiction: 18, romance: 20, fantasy: 18, thrillers: 12,
  }, {
    year: 1976, mysteries: 12, scienceFiction: 12, romance: 5, fantasy: 2, thrillers: 3,
  }, {
    year: 1977, mysteries: 18, scienceFiction: 16, romance: 1, fantasy: 6, thrillers: 3,
  }, {
    year: 1978, mysteries: 3, scienceFiction: 13, romance: 9, fantasy: 15, thrillers: 11,
  }, {
    year: 1979, mysteries: 11, scienceFiction: 13, romance: 14, fantasy: 1, thrillers: 12,
  }, {
    year: 1980, mysteries: 6, scienceFiction: 19, romance: 16, fantasy: 6, thrillers: 16,
  }, {
    year: 1981, mysteries: 2, scienceFiction: 15, romance: 4, fantasy: 6, thrillers: 13,
  }, {
    year: 1982, mysteries: 4, scienceFiction: 17, romance: 20, fantasy: 7, thrillers: 10,
  }, {
    year: 1983, mysteries: 3, scienceFiction: 2, romance: 18, fantasy: 18, thrillers: 17,
  }, {
    year: 1984, mysteries: 10, scienceFiction: 19, romance: 6, fantasy: 13, thrillers: 11,
  }, {
    year: 1985, mysteries: 16, scienceFiction: 6, romance: 5, fantasy: 2, thrillers: 7,
  }, {
    year: 1986, mysteries: 17, scienceFiction: 4, romance: 8, fantasy: 10, thrillers: 4,
  }, {
    year: 1987, mysteries: 9, scienceFiction: 18, romance: 17, fantasy: 6, thrillers: 9,
  }, {
    year: 1988, mysteries: 6, scienceFiction: 8, romance: 17, fantasy: 13, thrillers: 1,
  }, {
    year: 1989, mysteries: 3, scienceFiction: 10, romance: 13, fantasy: 17, thrillers: 2,
  }, {
    year: 1990, mysteries: 10, scienceFiction: 8, romance: 14, fantasy: 12, thrillers: 7,
  }, {
    year: 1991, mysteries: 18, scienceFiction: 1, romance: 2, fantasy: 8, thrillers: 16,
  }, {
    year: 1992, mysteries: 19, scienceFiction: 18, romance: 11, fantasy: 20, thrillers: 11,
  }, {
    year: 1993, mysteries: 7, scienceFiction: 14, romance: 4, fantasy: 8, thrillers: 10,
  }, {
    year: 1994, mysteries: 2, scienceFiction: 18, romance: 13, fantasy: 11, thrillers: 15,
  }, {
    year: 1995, mysteries: 2, scienceFiction: 6, romance: 7, fantasy: 11, thrillers: 10,
  }, {
    year: 1996, mysteries: 10, scienceFiction: 19, romance: 17, fantasy: 17, thrillers: 9,
  }, {
    year: 1997, mysteries: 3, scienceFiction: 7, romance: 4, fantasy: 15, thrillers: 9,
  }, {
    year: 1998, mysteries: 13, scienceFiction: 1, romance: 7, fantasy: 16, thrillers: 13,
  }, {
    year: 1999, mysteries: 19, scienceFiction: 7, romance: 18, fantasy: 14, thrillers: 1,
  }, {
    year: 2000, mysteries: 2, scienceFiction: 11, romance: 12, fantasy: 11, thrillers: 5,
  }, {
    year: 2001, mysteries: 16, scienceFiction: 9, romance: 12, fantasy: 6, thrillers: 8,
  }, {
    year: 2002, mysteries: 11, scienceFiction: 15, romance: 2, fantasy: 9, thrillers: 3,
  }, {
    year: 2003, mysteries: 1, scienceFiction: 6, romance: 9, fantasy: 9, thrillers: 16,
  }, {
    year: 2004, mysteries: 18, scienceFiction: 14, romance: 3, fantasy: 2, thrillers: 11,
  }, {
    year: 2005, mysteries: 9, scienceFiction: 16, romance: 7, fantasy: 8, thrillers: 20,
  }, {
    year: 2006, mysteries: 18, scienceFiction: 2, romance: 5, fantasy: 6, thrillers: 16,
  }, {
    year: 2007, mysteries: 5, scienceFiction: 17, romance: 14, fantasy: 4, thrillers: 7,
  }, {
    year: 2008, mysteries: 15, scienceFiction: 2, romance: 12, fantasy: 3, thrillers: 8,
  }, {
    year: 2009, mysteries: 16, scienceFiction: 20, romance: 7, fantasy: 14, thrillers: 11,
  }, {
    year: 2010, mysteries: 14, scienceFiction: 11, romance: 3, fantasy: 1, thrillers: 6,
  }, {
    year: 2011, mysteries: 18, scienceFiction: 20, romance: 5, fantasy: 4, thrillers: 5,
  }, {
    year: 2012, mysteries: 3, scienceFiction: 3, romance: 10, fantasy: 5, thrillers: 18,
  }, {
    year: 2013, mysteries: 1, scienceFiction: 1, romance: 0, fantasy: 6, thrillers: 16,
  }, {
    year: 2014, mysteries: 15, scienceFiction: 7, romance: 1, fantasy: 2, thrillers: 20,
  }, {
    year: 2015, mysteries: 12, scienceFiction: 19, romance: 3, fantasy: 3, thrillers: 12,
  }, {
    year: 2016, mysteries: 11, scienceFiction: 20, romance: 11, fantasy: 5, thrillers: 17,
  }, {
    year: 2017, mysteries: 4, scienceFiction: 20, romance: 3, fantasy: 12, thrillers: 5,
  }];
  

  
  export const sales = {
    2017: [
      { month: 'Jan', sale: 50, total: 987 },
      { month: 'Feb', sale: 100, total: 3000 },
      { month: 'Mar', sale: 30, total: 1100 },
      { month: 'Apr', sale: 107, total: 7100 },
      { month: 'May', sale: 95, total: 4300 },
      { month: 'Jun', sale: 150, total: 7500 },
      { month: 'Jul', sale: 120, total: 5300 },
      { month: 'Aug', sale: 110, total: 2500 },
      { month: 'Sep', sale: 54, total: 2300 },
      { month: 'Oct', sale: 129, total: 2600 },
      { month: 'Nov', sale: 48, total: 3400 },
      { month: 'Dec', sale: 43, total: 3200 },
    ],
    2018: [
      { month: 'Jan', sale: 100, total: 1000 },
      { month: 'Feb', sale: 200, total: 4300 },
      { month: 'Mar', sale: 50, total: 1200 },
      { month: 'Apr', sale: 127, total: 7150 },
      { month: 'May', sale: 105, total: 4340 },
      { month: 'Jun', sale: 180, total: 7520 },
      { month: 'Jul', sale: 150, total: 5380 },
      { month: 'Aug', sale: 120, total: 2590 },
      { month: 'Sep', sale: 59, total: 2700 },
      { month: 'Oct', sale: 139, total: 2800 },
      { month: 'Nov', sale: 66, total: 3450 },
      { month: 'Dec', sale: 55, total: 3260 },
    ],
    2019: [
      { month: 'Jan', sale: 170, total: 856 },
      { month: 'Feb', sale: 150, total: 3574 },
      { month: 'Mar', sale: 10, total: 1198 },
      { month: 'Apr', sale: 33, total: 6150 },
      { month: 'May', sale: 84, total: 3340 },
      { month: 'Jun', sale: 120, total: 5520 },
      { month: 'Jul', sale: 110, total: 3380 },
      { month: 'Aug', sale: 90, total: 1890 },
      { month: 'Sep', sale: 29, total: 1900 },
      { month: 'Oct', sale: 118, total: 2300 },
      { month: 'Nov', sale: 48, total: 3198 },
      { month: 'Dec', sale: 12, total: 2410 },
    ],
  };
  